const fontFamily = {
	base: `"Gotham", helvetica, arial, sans-serif`,
	alt: `"Coconat", garamond, serif`,
};

const fontWeight = {
	regular: "400",
	medium: "500",
	bold: "700",
	black: "900",
};

const Typography = {
	fontFamily,
	fontWeight,
};

export default Typography;
